import React from 'react';
import Icon from 'components/general/icon/icon';

interface OptionButtonProps {
  label: string;
  isSelected: boolean;
  onClick: () => void;
  className?: string;
}

const OptionButton: React.FC<OptionButtonProps> = ({
  label,
  isSelected,
  onClick,
  className = '',
}) => {
  const styles = require('./OptionButton.module.scss');
  
  const buttonClass = `${styles.optionButton} ${
    isSelected ? styles.active : ''
  } ${className}`;

  return (
    <button
      type="button"
      className={buttonClass}
      onClick={onClick}
    >
      <span>{label}</span>
      {isSelected && (
        <Icon
          name="check"
          color='tuftsBlueBase'
        />
      )}
    </button>
  );
};

export default OptionButton;
